export default __webpack_public_path__ + "static/media/rt-4.65b1d2b8.svg";